import { render, staticRenderFns } from "./Scrollbar.vue?vue&type=template&id=523a1da5&"
import script from "./Scrollbar.vue?vue&type=script&lang=ts&"
export * from "./Scrollbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports